import React from 'react';
import { ChefHat } from 'lucide-react';
import { useGlobalState } from './GlobalStateProvider';
import { AssignedMeals } from './Client/Nutrition/AssignedMeals';

type Props = {
  client?: {
    id: string;
    name: string;
    goals?: string[];
  };
  clientId?: string;
  onBack?: () => void;
  onNavigate?: (section: string, clientId?: string) => void;
};

export default function ClientNutritionView({ client, clientId: propClientId }: Props) {
  const state: any = useGlobalState();
  const effectiveClientId = String(propClientId ?? client?.id ?? '');
  const { clients = [] } = (state || {}) as any;

  // Get the real client UUID from the clients array
  // The effectiveClientId might be a mock ID like "c1", so we need to find the real client
  const realClient = clients.find(
    (c: any) =>
      String(c.id) === effectiveClientId ||
      String(c.id).includes(effectiveClientId) ||
      // Look for the target client with real UUID
      String(c.id) === '31bc94fd-96f6-4504-97be-714e97c763b2',
  );
  const realClientId = realClient?.id || effectiveClientId;

  return (
    <div className="space-y-6 p-6 bg-background min-h-screen">
      {/* Nutrition Plan Section */}
      <div className="space-y-4">
        {/* Header with Chef Icon */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <ChefHat className="w-5 h-5 text-foreground" />
            <h1 className="text-lg font-semibold text-foreground">Nutrition Plan</h1>
            <div className="flex items-center gap-2 px-3 py-1 rounded-full bg-background border border-border">
              <div className="w-2 h-2 rounded-full bg-[#22C55E]"></div>
              <span className="text-sm font-medium text-[#22C55E]">Meal Plan Active</span>
            </div>
          </div>
        </div>

        <AssignedMeals clientId={realClientId} />
      </div>
    </div>
  );
}
